import { useEffect, useState } from 'react';

export default function StatusCheck(props) {
    const [status, setStatus] = useState('loading'); // loading | ok | maintenance
    const [maintenanceMessage, setMaintenanceMessage] = useState('');

    useEffect(() => {
        fetch(`${process.env.REACT_APP_CONFIG_BUCKET_LOCATION}/system-status.json`)
            .then((res) => res.json())
            .then((data) => {
                setStatus(data?.status === 'maintenance' ? 'maintenance' : 'ok');
                setMaintenanceMessage(data?.message_en || '');
            })
            .catch(() => {
                setStatus('ok');
            })
    }, []);

    if (status === 'loading') {
        return null;
    }

    if (status === 'maintenance') {
        return (
            <main
                style={{
                    minHeight: '100vh',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '2rem',
                    textAlign: 'center',
                }}
            >
                <div>
                    <img src={`${process.env.REACT_APP_STOREFRONT_S3_LOCATION}/web/frontdoor-plus-logo-wide-black.png`} style={{ height: 128, paddingBottom: 28 }} alt='FrontDoor+ Logo' />
                    <h1>We'll Be Back Shortly</h1>
                    <p>{maintenanceMessage || 'The site is currently under maintenance. Please come back later'}</p>
                </div>
            </main>
        );
    }

    return props.children
}
